import { render, staticRenderFns } from "./ProductCart.vue?vue&type=template&id=8755db18&scoped=true"
import script from "./ProductCart.vue?vue&type=script&lang=js"
export * from "./ProductCart.vue?vue&type=script&lang=js"
import style0 from "./ProductCart.vue?vue&type=style&index=0&id=8755db18&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8755db18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src172433779/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8755db18')) {
      api.createRecord('8755db18', component.options)
    } else {
      api.reload('8755db18', component.options)
    }
    module.hot.accept("./ProductCart.vue?vue&type=template&id=8755db18&scoped=true", function () {
      api.rerender('8755db18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductCart.vue"
export default component.exports